import { getChatSession } from './getChatSession'
import { getConversationFromChatThread } from './getConversationFromChatThread'
import { renderChat } from './renderChat'
import { saveChatSession } from './saveChatSession'

/**
 * @param {LCChatIncomingChatEvent} payload
 */
export function handleChatIcomingChat(payload) {
  const session = getChatSession()
  saveChatSession({
    ...session,
    chatId: payload.chat.id,
    conversation: getConversationFromChatThread(payload.chat.thread),
  })

  renderChat()
}
